export function median(values: number[]) {
	if (values.length === 0) return 0
	values = values.toSorted()
	if (values.length % 2 === 0) {
		const i = values.length / 2
		return (values[i - 1]! + values[i]!) / 2
	} else {
		return values[Math.floor(values.length / 2)]!
	}
}
